import { render } from "./ImageFeatureCardShell.vue?vue&type=template&id=66c615ff&scoped=true"
import script from "./ImageFeatureCardShell.vue?vue&type=script&lang=js"
export * from "./ImageFeatureCardShell.vue?vue&type=script&lang=js"

import "./ImageFeatureCardShell.vue?vue&type=style&index=0&id=66c615ff&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c615ff"]])

export default __exports__